<div class="row">
    <div class="col-12">
        <div class="content-header">Session Form</div>
    </div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
    <div class="row">
        <div class="col-12">
            <div class="card">

                <div class="card-content w-50 m-auto">
                    <div class="card-body">
                            <div class="col-md">
                                <form [formGroup]="classTemplateForm">
                                    <fieldset class="form-group">
                                        <label>Session Name<span class="required_field">*</span></label>
                                        <input class="form-control" type="text" formControlName="title" [(ngModel)]="class_temp_model.title" placeholder="Session Name">
                                    </fieldset>
                                    <fieldset class="mb-3">
                                        <label>Course<span class="required_field">*</span></label>
                                        <ng-select [disabled]="isEdit" [items]="course_list" bindLabel="title" bindValue="_id" placeholder="Select Course"
                                            [(ngModel)]="select_course" [ngModelOptions]="{ standalone: true }"
                                            [closeOnSelect]="false" (change)="getCourseId($event)" readonly="readonly">
                                        </ng-select>
                                    </fieldset>
                                    <!-- <fieldset class="form-group">
                                        <label>Topic Name<span class="required_field">*</span></label>
                                        <ng-select [items]="topic_list" [multiple]="true" bindLabel="name" bindValue="_id" placeholder="Select topic"
                                        [(ngModel)]="select_topic" [multiple]="true" [ngModelOptions]="{ standalone: true }"
                                        [closeOnSelect]="false" (change)="getTopicId($event)">
                                    </ng-select>
                                    </fieldset> -->
                                    <fieldset>
                                        
                                      <div class="container-fluid" *ngIf="select_course">
                                 <div class="row min-hieght-2500px display_block lms-cstm-content">
                                   <div class="col-md-12 col-lg-12 col-sm-12 col-12 side-bar-cstm" [style.display]="isDivVisible ? 'block' : 'none'" [hidden]="isSideBarHidden">
                                 
                                   <div class="list-group" id="items"> 
                                     <!-- <div class="modal-cross-wrap">
                                     <i class="ft-x cursor-pointer" (click)="toggleVisibility()"></i>
                                   </div> -->
                                   <ul>
                                 <li class="cursor" *ngFor="let section of sections; let sectionIndex = index">
                                   <div class="list-group-item section-list">
                                     <div class="sidee-nav-section">
                                       <div class="list-title">
                                         <input type="checkbox" [name]="'sectionIndex'+sectionIndex" class="checkbox-style" [(ngModel)]="section.checked" (change)="sectionSelection($event,sectionIndex)" [ngModelOptions]="{standalone: true}">
                                         {{ section?.name }}
                                         <i *ngIf="section?.chapters?.length>0" class="ft-chevron-down" (click)="activeBreadcrumb(section?.name, section?._id)" data-toggle="collapse" [attr.data-target]="'#sectionCollapse' + sectionIndex" [ngClass]="{'active-section': activeSectionId == section?._id}"></i>
                                       </div>
                                     </div>
                                     <ul [id]="'sectionCollapse' + sectionIndex" class="collapse" [ngbCollapse]="'#sectionCollapse' + sectionIndex" [class.show]="sectionIndex === 0">
                                       <li class="cursor" *ngFor="let chapter of section?.chapters; let chapterIndex = index">
                                         <div class="list-group-item chapter-list" [ngClass]="{'active-chapter': activeChapterId == chapter?._id}">
                                           <div (click)="activeBreadcrumb(section?.name, section?._id, chapter?.name, chapter?._id)" data-toggle="collapse" class="inner-chapter" [attr.data-target]="'#chapterCollapse' + sectionIndex + '-' + chapterIndex">
                                             <div class="list-title">
                                               <input type="checkbox" [name]="'chapterIndex'+chapterIndex" class="checkbox-style" [(ngModel)]="chapter.checked" [value]="chapter.checked" (change)="chapterSelection($event,sectionIndex,chapterIndex)" [ngModelOptions]="{standalone: true}">
                                               {{ chapter?.name }}
                                               <i *ngIf="chapter?.topics?.length>0" class="ft-chevron-down"></i>
                                             </div>
                                           </div>
                                           <ul [id]="'chapterCollapse' + sectionIndex + '-' + chapterIndex" class="collapse" [ngbCollapse]="'#chapterCollapse' + sectionIndex + '-' + chapterIndex" [class.show]="sectionIndex === 0 && chapterIndex === 0">
                                             <li class="cursor" *ngFor="let topic of chapter.topics; let topicIndex = index">
                                               <div class="list-group-item topic-list" [ngClass]="{'active-topic': activeTopicId == topic?._id}">
                                                 <div class="list-title">
                                                   <input type="checkbox" [name]="'topicIndex'+topicIndex" class="checkbox-style" [(ngModel)]="topic.checked" (change)="topicSelection($event,sectionIndex,chapterIndex,topicIndex)" [ngModelOptions]="{standalone: true}">
                                                   {{ topic.name }}
                                                 </div>
                                               </div>
                                             </li>
                                           </ul>
                                         </div>
                                       </li>
                                     </ul>
                                   </div>
                                 </li>
                               </ul>
                               
                                   </div>
                                 
                                   </div>
                                  
                                   <!-- {'col-12': isSideBarHidden} -->
                                 
                                   <!-- <div [ngClass]="{'col-md-9': isDivVisible, 'col-md-12': !isDivVisible ,'video-container': true}">
                                   
                                 
                                   </div> -->
                                 
                                   <div class="lms-btn-cstm-wrap">
                                   <button *ngIf="!isDivVisible" (click)="toggleVisibility()" class="btn btn-primary lms-btnn">
                                     <span>Course Content</span>
                                     <i class="fa-solid fa-arrow-right"></i>
                                   </button>
                                   
                                   </div>
                                 </div>
                                 </div>
                                                                   </fieldset>
                                     <fieldset class="form-group">
                                        <label>Admin Notes</label>
                                         <textarea formControlName="admin_notes" [(ngModel)]="class_temp_model.admin_notes" name="admin_notes" id="admin_notes" rows="3" class="form-control" placeholder="Admin notes"></textarea>
                                    </fieldset>
                                   
                                </form>
                            </div>
                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2">
                                <button [disabled]="class_temp_model.title == '' || !select_course" type="submit" class="btn btn-primary mb-2 mb-sm-0 mr-sm-2" (click)="submit()">
                                    Submit
                                </button>
                                <button type="reset" class="btn btn-secondary" (click)="back()">
                                    Cancel
                                </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>